/* Keyteks: banner (titulo / foto / super oferta), cuentas regresivas, entrega hoy, franja rotativa,
   carrusel de ofertas automatico, ventanas de informacion, mapa de cobertura e icono de 10%. */
(function () {
  function buildSlides() {
    var slider = document.querySelector("#MainContent [id^='Slider-'].slideshow");
    if (!slider) return;
    var slides = slider.querySelectorAll('.slideshow__slide');
    slides.forEach(function (slide, i) {
      var tw = slide.querySelector('.slideshow__text-wrapper');
      if (!tw || slide.classList.contains('kt-ready')) return;
      var heading = tw.querySelector('.banner__heading');
      var btn = tw.querySelector('.banner__buttons a');
      var sub = tw.querySelector('.banner__text');

      var st = document.createElement('div');
      st.className = 'kt-st';
      var h = document.createElement('h2');
      h.textContent = heading ? heading.textContent.trim() : '';
      st.appendChild(h);
      if (btn && btn.getAttribute('href')) {
        var a = document.createElement('a');
        a.href = btn.getAttribute('href');
        a.textContent = btn.textContent.trim() + ' ›';
        st.appendChild(a);
      }

      var of = document.createElement('div');
      of.className = 'kt-sof';
      var tpl = document.querySelector('template[data-kt-offer="' + (i + 1) + '"]');
      if (tpl) {
        of.appendChild(tpl.content.cloneNode(true));
      } else if (sub && sub.textContent.trim()) {
        var p = document.createElement('p');
        p.className = 'kt-sub';
        p.textContent = sub.textContent.trim();
        of.appendChild(p);
      }

      slide.insertBefore(st, slide.firstChild);
      slide.appendChild(of);
      slide.classList.add('kt-ready');
    });
    slider.classList.add('kt-on');

    /* Mientras el dedo esta sobre el banner se detiene el cambio automatico (evita que se trabe) */
    var comp = slider.closest('slideshow-component');
    var back;
    if (comp) {
      slider.addEventListener('touchstart', function () {
        clearTimeout(back);
        if (typeof comp.pause === 'function') comp.pause();
      }, { passive: true });
      slider.addEventListener('touchend', function () {
        clearTimeout(back);
        back = setTimeout(function () {
          if (typeof comp.play === 'function' && slider.getAttribute('data-autoplay') === 'true') comp.play();
        }, 6000);
      }, { passive: true });
    }
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function startTimers() {
    var timers = document.querySelectorAll('.kt-timer[data-end]');
    if (!timers.length) return;
    function tick() {
      var now = Date.now();
      timers.forEach(function (t) {
        var end = Date.parse(t.getAttribute('data-end'));
        var out = t.querySelector('b');
        if (isNaN(end) || !out) { t.style.display = 'none'; return; }
        var d = Math.floor((end - now) / 1000);
        if (d <= 0) { t.style.display = 'none'; return; }
        var days = Math.floor(d / 86400);
        var hh = Math.floor((d % 86400) / 3600);
        var mm = Math.floor((d % 3600) / 60);
        var ss = d % 60;
        out.textContent = (days > 0 ? days + 'd ' : '') + pad(hh) + ':' + pad(mm) + ':' + pad(ss);
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* Entrega el mismo dia: compras antes de las 13:00 (hora de Chile), Santiago urbano */
  var CUTOFF_HOUR = 13;
  function chileMinutes() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'America/Santiago', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var h = 0, m = 0;
      parts.forEach(function (p) { if (p.type === 'hour') h = parseInt(p.value, 10) % 24; if (p.type === 'minute') m = parseInt(p.value, 10); });
      return h * 60 + m;
    } catch (e) { return null; }
  }
  function sameDayHtml() {
    var now = chileMinutes();
    if (now === null) return null;
    var left = CUTOFF_HOUR * 60 - now;
    if (left > 0) {
      var h = Math.floor(left / 60), m = left % 60;
      var t = (h > 0 ? h + ' h ' : '') + m + ' min';
      return 'Pide en <b>' + t + '</b> y recíbelo <b>hoy</b> en Santiago urbano';
    }
    return 'Pide ahora y recíbelo <b>mañana</b> en Santiago urbano';
  }
  function sameDay() {
    var html = sameDayHtml();
    if (!html) return;
    var targets = [];
    var pp = document.querySelector('.kt-pp');
    if (pp) {
      var box = document.createElement('div');
      box.className = 'kt-sd';
      box.innerHTML = "<svg viewBox='0 0 24 24'><path d='M13 2 4 14h7l-1 8 9-12h-7z'/></svg><span></span>";
      pp.parentNode.insertBefore(box, pp);
      targets.push(box.querySelector('span'));
    }
    document.querySelectorAll('.kt-rot').forEach(function (rot) {
      var s = document.createElement('span');
      var on = rot.querySelector('.on');
      if (on) on.classList.remove('on');
      s.className = 'on';
      rot.insertBefore(s, rot.firstChild);
      targets.push(s);
    });
    function paint() {
      var h = sameDayHtml();
      if (h) targets.forEach(function (t) { t.innerHTML = h; });
    }
    paint();
    setInterval(paint, 30000);
  }

  /* Franja de mensajes: cambia cada 5 segundos */
  function rotate() {
    document.querySelectorAll('.kt-rot').forEach(function (r) {
      var k = r.children, i = 0;
      if (k.length < 2) return;
      setInterval(function () {
        k[i].classList.remove('on');
        i = (i + 1) % k.length;
        k[i].classList.add('on');
      }, 5000);
    });
  }

  function autoCarousel() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var list = document.querySelector('#MainContent slider-component .product-grid.slider');
    if (!list) return;
    var paused = false, resume, lastLeft = -1, rewinding = false;
    function hold(ms) {
      paused = true;
      clearTimeout(resume);
      if (ms) resume = setTimeout(function () { paused = false; }, ms);
    }
    function rewind() {
      if (rewinding) return;
      rewinding = true;
      list.classList.add('kt-fade');
      setTimeout(function () {
        list.style.scrollSnapType = 'none';
        list.style.scrollBehavior = 'auto';
        list.scrollLeft = 0;
        lastLeft = -1;
        setTimeout(function () {
          list.style.scrollSnapType = '';
          list.style.scrollBehavior = '';
          list.classList.remove('kt-fade');
          rewinding = false;
        }, 80);
      }, 360);
    }
    list.addEventListener('mouseenter', function () { hold(0); });
    list.addEventListener('mouseleave', function () { paused = false; });
    list.addEventListener('touchstart', function () { hold(8000); }, { passive: true });
    list.addEventListener('focusin', function () { hold(8000); });
    setInterval(function () {
      if (paused || rewinding || document.hidden) return;
      var r = list.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var item = list.querySelector('.grid__item');
      if (!item) return;
      var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      var step = item.offsetWidth + gap;
      var left = list.scrollLeft;
      var atEnd = left + list.clientWidth >= list.scrollWidth - 8;
      var stuck = lastLeft >= 0 && Math.abs(left - lastLeft) < 2;
      if (atEnd || stuck) {
        rewind();
      } else {
        lastLeft = left;
        list.scrollBy({ left: step, behavior: 'smooth' });
      }
    }, 4500);
  }

  /* Ventanas de informacion: <button data-kt-modal='id'> abre <dialog id='kt-m-id'> */
  function modals() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest ? e.target.closest('[data-kt-modal]') : null;
      if (opener) {
        var d = document.getElementById('kt-m-' + opener.getAttribute('data-kt-modal'));
        if (d && typeof d.showModal === 'function') { e.preventDefault(); d.showModal(); }
        return;
      }
      var closer = e.target.closest ? e.target.closest('[data-kt-close]') : null;
      if (closer) { var dlg = closer.closest('dialog'); if (dlg) dlg.close(); return; }
      if (e.target.tagName === 'DIALOG' && e.target.classList.contains('kt-modal')) e.target.close();
    });
  }

  /* Cobertura de entrega el mismo dia (comunas de Flex). [nombre, columna, fila] en una grilla de 6 columnas */
  var COMUNAS = [
    ['Colina', 4, 1],
    ['Quilicura', 3, 2], ['Huechuraba', 4, 2], ['Lo Barnechea', 6, 2],
    ['Pudahuel', 1, 3], ['Renca', 2, 3], ['Conchalí', 3, 3], ['Recoleta', 4, 3], ['Vitacura', 5, 3], ['Las Condes', 6, 3],
    ['Cerro Navia', 1, 4], ['Quinta Normal', 2, 4], ['Independencia', 3, 4], ['Providencia', 4, 4], ['Ñuñoa', 5, 4], ['La Reina', 6, 4],
    ['Lo Prado', 1, 5], ['Estación Central', 2, 5], ['Santiago', 3, 5], ['San Joaquín', 4, 5], ['Macul', 5, 5], ['Peñalolén', 6, 5],
    ['Maipú', 1, 6], ['Cerrillos', 2, 6], ['Pedro Aguirre Cerda', 3, 6], ['San Miguel', 4, 6], ['La Granja', 5, 6], ['La Florida', 6, 6],
    ['Padre Hurtado', 1, 7], ['Lo Espejo', 2, 7], ['La Cisterna', 3, 7], ['San Ramón', 4, 7], ['La Pintana', 5, 7], ['Puente Alto', 6, 7],
    ['San Bernardo', 2, 8], ['El Bosque', 3, 8]
  ];
  var SHORT = { 'Pedro Aguirre Cerda': 'P. Aguirre Cerda' };
  var ALIAS = { 'santiago centro': 'santiago', 'stgo': 'santiago', 'santiago de chile': 'santiago', 'las condes de santiago': 'las condes', 'pac': 'pedro aguirre cerda', 'chicureo': 'colina', 'la dehesa': 'lo barnechea' };
  function norm(s) {
    s = String(s || '').toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return s.replace(/[^a-z ]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function findComuna(text) {
    var q = norm(text);
    if (!q) return null;
    if (ALIAS[q]) q = ALIAS[q];
    for (var i = 0; i < COMUNAS.length; i++) if (norm(COMUNAS[i][0]) === q) return COMUNAS[i];
    return null;
  }
  function coverage() {
    document.querySelectorAll('[data-kt-cov]').forEach(function (box) {
      var input = box.querySelector('input');
      var out = box.querySelector('.kt-cov__r');
      var map = box.querySelector('.kt-cov__m');
      var list = box.querySelector('datalist');
      if (!input || !out || !map) return;
      var tiles = {};
      COMUNAS.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.title = c[0];
        b.lang = 'es';
        b.style.gridColumn = String(c[1]);
        b.style.gridRow = String(c[2]);
        b.textContent = SHORT[c[0]] || c[0];
        b.addEventListener('click', function () { input.value = c[0]; show(c[0], false); });
        map.appendChild(b);
        tiles[c[0]] = b;
        if (list) { var o = document.createElement('option'); o.value = c[0]; list.appendChild(o); }
      });
      function show(text, mine) {
        Object.keys(tiles).forEach(function (k) { tiles[k].classList.remove('is-on'); });
        out.classList.remove('is-yes', 'is-no');
        var clean = String(text || '').trim();
        if (clean.length < 3) { out.textContent = 'Escribe tu comuna o tócala en el mapa.'; return; }
        var c = findComuna(clean);
        if (c) {
          tiles[c[0]].classList.add('is-on');
          out.classList.add('is-yes');
          out.textContent = (mine ? 'Tu dirección en ' + c[0] + ' está dentro de la cobertura: ' : 'Sí, llegamos a ' + c[0] + ': ') + 'comprando antes de las 13:00 lo recibes hoy.';
        } else {
          out.classList.add('is-no');
          out.textContent = (mine ? 'Tu dirección en ' + clean + ' queda fuera de la entrega el mismo día. ' : 'Por ahora no tenemos entrega el mismo día en ' + clean + '. ') + 'Te lo enviamos por despacho normal a todo Chile.';
        }
      }
      input.addEventListener('input', function () { show(input.value, false); });
      var city = box.getAttribute('data-city');
      if (city) { input.value = city; show(city, true); } else { show('', false); }
    });
  }

  /* Icono de 10% (teaser de Shopify Forms) sobre el de WhatsApp; la primera visita muestra el mensaje */
  var FORMS_CSS = '#app-embed[data-current-step=tease]{top:auto!important;bottom:84px!important;right:24px!important;left:auto!important;transform:none!important;rotate:0deg!important;padding:0!important;width:auto!important}' +
    '#app-embed[data-current-step=tease] [data-testid=app-router]{rotate:0deg!important;transform:none!important}' +
    '#app-embed[data-current-step=tease] [data-testid=form-teaser]{position:relative;overflow:visible!important;display:flex!important;align-items:center;justify-content:center;width:48px!important;height:48px!important;min-width:0!important;padding:0!important;border-radius:50%!important;background:#e11d48!important;border:0!important;box-shadow:0 4px 12px rgba(0,0,0,.3)!important;cursor:pointer}' +
    '#app-embed[data-current-step=tease] [data-testid=form-teaser] h3{font-size:0!important;margin:0!important;line-height:1!important;width:34px}' +
    '#app-embed[data-current-step=tease] [data-testid=form-teaser] h3::before{content:"10% OFF";display:block;font:700 12px/1.05 Arial,sans-serif;color:#fff;text-align:center}' +
    '#app-embed[data-current-step=tease] [aria-label="Close modal"]{display:none!important}' +
    ':host([data-kt-first]) #app-embed[data-current-step=tease] [data-testid=form-teaser]::after{content:"10% de descuento en tu primera compra";position:absolute;right:58px;top:50%;transform:translateY(-50%);background:#e11d48;color:#fff;font:600 13px/1.2 Arial,sans-serif;padding:8px 12px;border-radius:20px;white-space:nowrap;box-shadow:0 2px 8px rgba(0,0,0,.25);animation:ktLbl .5s ease 7s forwards}' +
    '@keyframes ktLbl{to{opacity:0;visibility:hidden}}' +
    '@media (max-width:749px){#app-embed[data-current-step=tease]{bottom:72px!important;right:14px!important}}';
  function formsIcon() {
    var first = false;
    try {
      if (!localStorage.getItem('kt_off_seen')) { first = true; localStorage.setItem('kt_off_seen', '1'); }
    } catch (e) {}
    var n = 0;
    var t = setInterval(function () {
      var f = document.querySelector('shopify-forms-embed');
      var root = f && f.shadowRoot;
      var app = root && root.querySelector('#app-embed');
      if (app) {
        clearInterval(t);
        if (!root.querySelector('#kt-forms')) {
          var s = document.createElement('style');
          s.id = 'kt-forms';
          s.textContent = FORMS_CSS;
          root.appendChild(s);
        }
        if (first) f.setAttribute('data-kt-first', '');
        /* En movil el formulario solo se abre si la persona toca el icono (no al entrar al sitio) */
        var userOpened = false;
        root.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('[data-testid=form-teaser]')) userOpened = true;
        }, true);
        if (window.MutationObserver && window.matchMedia && window.matchMedia('(max-width:749px)').matches) {
          var guard = function () {
            var step = app.getAttribute('data-current-step');
            if (step === 'tease') { userOpened = false; return; }
            if (!userOpened) {
              var x = root.querySelector('[aria-label="Close modal"]');
              if (x) x.click();
            }
          };
          new MutationObserver(guard).observe(app, { attributes: true, attributeFilter: ['data-current-step'] });
          guard();
        }
        return;
      }
      if (++n > 60) clearInterval(t);
    }, 500);
  }

  function init() { buildSlides(); startTimers(); sameDay(); rotate(); autoCarousel(); modals(); coverage(); formsIcon(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
